// eslint-disable-next-line max-lines
/* global process */
import {
    sendCommand,
    sendNotification as webToClientNotification,
    sendErrorNotification as webToClientErrorNotification,
    defaultWoTClientMessageHandler,
    getToken1,
    openExternalBrowser,
    openWindow,
} from 'react-wot-bootstrap'
import isFunction from 'lodash/isFunction'

const MEMBERS_ONLINE_WEB_ID = 'members_online'
const ACCESS_TOKEN_WEB_ID = 'access_token_web_id'
const INVENTORY_WEB_ID = 'inventory'
const INVENTORY_STYLES_WEB_ID = 'inventory_styles_web_id'
const CONTEXT_MENU_COMMAND = 'context_menu'
const BALANCE_WEB_ID = 'get_balance_web_id'
const GET_ITEMS_WEB_ID = 'get_items'
const GET_PREMIUM_INFO_WEB_ID = 'get_premium_info'
const GET_SERVER_TIMESTAMP_WEB_ID = 'server_timestamp'
const GET_NEWS_COUNTER_WEB_ID = 'get_news_counters'
const SET_NEWS_COUNTER_WEB_ID = 'set_news_counters'
const CLAN_INFO_STATUS = 'clan_info_status'
const GET_COMPARISON_BASKET_WEB_ID = 'get_comparison_basket_web_id'
const GET_VEHICLE_PARAMS_WEB_ID = 'get_vehicle_params_web_id'
const GET_VEHICLE_INFO_WEB_ID = 'get_vehicle_info_web_id'
const GET_RESERVE_PARAMS_WEB_ID = 'get_reserve_params'
const GET_AVAILABLE_PERIPHERIES = 'get_available_peripheries'

const WoTClientMessageCallbacks = {}

export const ItemType = {
    VEHICLE: 'vehicle',
    EQUIPMENT: 'equipment',
    DEVICE: 'device',
    BOOSTER: 'booster',
    BATTLEBOOSTER: 'battleBooster',
    MODULE: 'module',
    SHELL: 'shell',
    PREMIUM: 'premium',
    PAINT: 'paint',
    CAMOUFLAGE: 'camouflage',
    MODIFICATION: 'modification',
    STYLE: 'style',
    DECAL: 'decal',
    EMBLEM: 'emblem',
    INSCRIPTION: 'inscription',
    PROJECTIONDECAL: 'projectionDecal',
    ENHANCEMENTS: 'enhancements',
    CREW_BOOKS: 'crew_books',
}

export const GetItemsCriteria = {
    INVENTORY: 'inventory',
    PREMIUM: 'premium',
    READY: 'ready',
    SELLABLE: 'sellable',
    SECRET: 'secret',
    HIDDEN: 'hidden',
    IS_PREMIUM_IGR: 'is_premium_igr',
    ENABLED: 'enabled',
    BUILTIN: 'builtin',
    TRADE_IN: 'trade_in',
    TRADE_OFF: 'trade_off',
    SKIP_MULTINATIONAL_COPIES: 'skip_multinational_copies',
    NOT_INVENTORY: '!inventory',
    NOT_PREMIUM: '!premium',
    NOT_READY: '!ready',
    NOT_SELLABLE: '!sellable',
    NOT_SECRET: '!secret',
    NOT_HIDDEN: '!hidden',
    NOT_IS_PREMIUM_IGR: '!is_premium_igr',
    NOT_ENABLED: '!enabled',
    NOT_BUILTIN: '!builtin',
    NOT_TRADE_IN: '!trade_in',
    NOT_TRADE_OFF: '!trade_off',
    NOT_SKIP_MULTINATIONAL_COPIES: '!skip_multinational_copies',
}

export const REWARD_PACK_TYPE = {
    VEHICLE_LIGHTTANK: 'vehicle/lightTank',
    VEHICLE_MEDIUMTANK: 'vehicle/mediumTank',
    VEHICLE_HEAVYTANK: 'vehicle/heavyTank',
    VEHICLE_AT_SPG: 'vehicle/AT-SPG',
    VEHICLE_SPG: 'vehicle/SPG',
    ITEM_EQUIPMENT: 'item/equipment',
    ITEM_OPTIONALDEVICE: 'item/optionalDevice',
    ITEM_SHELL: 'item/shell',
    GOODIE_GOLD: 'goodie/gold',
    GOODIE_CREDITS: 'goodie/credits',
    GOODIE_EXPERIENCE: 'goodie/experience',
    GOODIE_FREE_EXPERIENCE: 'goodie/free_experience',
    GOODIE_CREW_EXPERIENCE: 'goodie/crew_experience',
    GOODIE_FL_EXPERIENCE: 'goodie/fl_experience',
    CREW_50: 'crew/50',
    CREW_75: 'crew/75',
    CREW_100: 'crew/100',
    CUSTOM_CREW_100: 'custom_crew/100',
    CREW_BUNDLE: 'crew/bundle',
    CREW_CUSTOM: 'crew/custom',
    CUSTOM_PREMIUM: 'custom/premium',
    CUSTOM_PREMIUM_PLUS: 'custom/premium_plus',
    CUSTOM_CRYSTAL: 'custom/crystal',
    CUSTOM_GOLD: 'custom/gold',
    CUSTOM_CREDITS: 'custom/credits',
    CUSTOM_EVENTCOIN: 'custom/eventCoin',
    CUSTOM_EVENT_COIN: 'custom/event_coin',
    CUSTOM_BPCOIN: 'custom/bpcoin',
    CUSTOM_SLOT: 'custom/slot',
    CUSTOM_CREW: 'custom/crew',
    CUSTOM_REWARD_POINT: 'custom/reward_point',
    CUSTOM_SUPPLY_POINT: 'custom/supply_point',
    TOKEN: 'token',
    PAINT_ALL: 'paint/all',
    PAINT_SUMMER: 'paint/summer',
    PAINT_WINTER: 'paint/winter',
    PAINT_DESERT: 'paint/desert',
    CAMOUFLAGE_ALL: 'camouflage/all',
    CAMOUFLAGE_SUMMER: 'camouflage/summer',
    CAMOUFLAGE_WINTER: 'camouflage/winter',
    CAMOUFLAGE_DESERT: 'camouflage/desert',
    DECAL_1: 'decal/1',
    DECAL_2: 'decal/2',
    PROJECTION_DECAL_ALL: 'projection_decal/all',
    PERSONAL_NUMBER_ALL: 'personal_number/all',
    MODIFICATION_ALL: 'modification/all',
    STYLE_ALL: 'style/all',
    EMBLEM: 'emblem',
    ACHIEVEMENT: 'achievement',
    BADGE: 'badge',
    REFERRALBADGE: 'referralBadge',
    PLAYERBADGES: 'playerBadges',
    SINGLEACHIEVEMENTS: 'singleAchievements',
    FRONTLINE_TOKEN: 'frontline_token',
    TRADEININFO: 'tradeInInfo',
    CREWBOOK: 'crewBook',
    CREW_BOOK_BROCHURE: 'crew_book/brochure',
    CREW_BOOK_GUIDE: 'crew_book/guide',
    CREW_BOOK_CREWBOOK: 'crew_book/crewBook',
    CREW_BOOK_PERSONALBOOK: 'crew_book/personalBook',
    CREW_BOOK_UNIVERSALBOOK: 'crew_book/universalBook',
    BLUEPRINT: 'blueprint',
    BLUEPRINT_NATIONAL: 'blueprint/national',
    BLUEPRINT_INTELLIGENCE_DATA: 'blueprint/intelligence_data',
    BLUEPRINT_ANY: 'blueprint/any',
}

export const REWARD_CATEGORY = {
    CUSTOMIZATIONS: 'customizations',
}

window.WoTClientMessageHandler = function(callbackString) {
    const { data, web_id, command } = JSON.parse(callbackString)
    if (command === CONTEXT_MENU_COMMAND) {
        return contextMenuCallback(data)
    }

    defaultWoTClientMessageHandler(callbackString)

    const callback = WoTClientMessageCallbacks[web_id]
    if (callback) callback(data)
}

// for react-wot-bootstrap 2.0.0 and WOT 1.0.1 userContextMenu from rwb doesn't work
// using implementation from react-wot-bootstrap 1.5.8
let contextMenuResolve = null
export const userContextMenu = (id, name, customItems = [], excludedItems = []) => {
    return new Promise((resolve) => {
        sendCommand({
            command: CONTEXT_MENU_COMMAND,
            params: {
                menu_type: 'user_menu',
                spa_id: id,
                user_name: name,
                custom_items: customItems,
                excluded_items: excludedItems,
            },
        })
        contextMenuResolve = resolve
    })
}

const contextMenuCallback = (data) => {
    if (contextMenuResolve && data) {
        const selectedItem = data.selected_item
        contextMenuResolve(selectedItem)
        contextMenuResolve = null
    }
}

export const getAccessTokenData = (force = false) => new Promise((resolve, reject) => {

    if (process.env.NODE_ENV === 'development' && !isFunction(window.jsHostQuery)) {
        // Only for debug purposes. Use inv auth.get_access_token -s <spa_id> to obtain <access_token>
        const accessToken = undefined
        const spaId = undefined
        if (accessToken && spaId) {
            return resolve({
                access_token: accessToken,
                spa_id: spaId,
                periphery_id: 0,
            })
        } else {
            return reject()
        }
    }

    const commandData = {
        command: 'request',
        params: {
            request_id: 'access_token',
            force,
        },
        web_id: ACCESS_TOKEN_WEB_ID,
    }
    WoTClientMessageCallbacks[commandData.web_id] = (data) => {
        if (Object.keys(data).length) {
            resolve(data)
        } else {
            reject()
        }
    }
    sendCommand(commandData)
})

export const requestMembersOnline = () => new Promise((resolve, reject) => {
    const commandData = {
        command: 'clan_management',
        params: {
            action: 'members_online',
        },
        web_id: MEMBERS_ONLINE_WEB_ID,
    }

    WoTClientMessageCallbacks[commandData.web_id] = (data) => {
        if (Object.keys(data).length) {
            resolve(data)
        } else {
            reject()
        }
    }
    sendCommand(commandData)
})

let inventoryPromise = null
export function requestInventory() {
    if (inventoryPromise) return inventoryPromise

    inventoryPromise = new Promise(resolve => {
        WoTClientMessageCallbacks[INVENTORY_WEB_ID] = (data) => {
            inventoryPromise = null
            resolve(data)
        }
    })

    sendCommand({
        command: 'shop',
        params: {
            action: 'get_items',
            type: 'vehicle',
            criteria: ['inventory', 'skip_multinational_copies'],
            fields: [
                'id',
                'isPremium',
                'level',
                'shortName',
                'nation',
                'type',
                'readiness',
                'techName',
                'isFavorite',
            ],
        },
        web_id: INVENTORY_WEB_ID,
    })

    return inventoryPromise
}

export function getStylesFromInventory(styleIds) {
    if (!(styleIds instanceof Array && styleIds.length > 0)) {
        styleIds = null
    }

    const stylePromise = new Promise(resolve => {
        WoTClientMessageCallbacks[INVENTORY_STYLES_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    const commandData = {
        command: 'shop',
        params: {
            action: 'get_items',
            type: 'style',
            criteria: ['on_account'],
        },
        web_id: INVENTORY_STYLES_WEB_ID,
    }

    if (styleIds) {
        commandData.params.id_list = styleIds
    }

    sendCommand(commandData)

    return stylePromise
}

export function requestVehiclesReadiness() {
    let inventoryPromise = new Promise(resolve => {
        WoTClientMessageCallbacks[INVENTORY_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'shop',
        params: {
            action: 'get_items',
            type: 'vehicle',
            criteria: ['inventory'],
            fields: [
                'id',
                'readiness',
            ],
        },
        web_id: INVENTORY_WEB_ID,
    })

    return inventoryPromise
}

export function openClanCard({ id, tag }) {
    sendCommand({
        command: 'open_window',
        params: {
            window_id: 'clan_card_window',
            clan_dbid: id,
            clan_abbrev: tag,
        },
    })
}

if (process.env.NODE_ENV === 'development') {
    window.WoTClientMessageCallbacks = WoTClientMessageCallbacks
}

export const NOTIFICATION_TYPE = {
    INFORMATION: 'Information',
    WARNING: 'Warning',
    ERROR: 'Error',
}

export function sendW2CNotification({ type, message, header, params }) {
    webToClientNotification(type, message, header, params)
}

export function sendClanSupplyErrorNotification() {
    const params = {
        type: 'Error',
        i18n_key: '#clan_supply:messages/claimRewards/error',
        i18n_data: {},
    }

    sendCommand({
        command: 'notification',
        params,
    })
}

export function sendErrorNotification(errorData) {
    webToClientErrorNotification(errorData.errorMessage, errorData.statusCode)
}

export function closeBattleRoomsList() {
    sendCommand({
        command: 'strongholds_battle',
        params: {
            action: 'leave_mode',
        },
    })
}

export async function openExternalBrowserWithAuth(signinTokenLink, link, withHost) {
    try {
        const { spaId, token1 } = await getToken1()
        const searchParams = new URLSearchParams()
        searchParams.append('token', token1)
        searchParams.append('account_id', spaId)
        const linkUrl = new URL(link)
        // linkUrl parts are already encoded, so it's required to decode next url before appending to URLSearchParams.
        // Otherwise, it'll be encoded twice
        const next = decodeURI(
            `${withHost ? linkUrl.origin : ''}${linkUrl.pathname}${linkUrl.search}${linkUrl.hash}`
        )
        searchParams.append('next', next)
        searchParams.append('continue_on_failure', '1')

        const queryString = searchParams.toString()
        const url = `${signinTokenLink}?${queryString}`
        openExternalBrowser(url)
    } catch (error) {
        openExternalBrowser(link)
    }
}

export function requestShopBalance() {
    const balancePromise = new Promise(resolve => {
        WoTClientMessageCallbacks[BALANCE_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'shop',
        params: {
            action: 'get_balance',
        },
        web_id: BALANCE_WEB_ID,
    })

    return balancePromise
}

export function getItems(type, criteria, fields, id_list) {
    const callbackId = `${GET_ITEMS_WEB_ID}-${type}`
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[callbackId] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'shop',
        params: {
            action: 'get_items',
            type,
            criteria,
            fields,
            id_list,
        },
        web_id: callbackId,
    })

    return promise
}

export function getPremiumInfo() {
    // mock:
    // return Promise.resolve({
    //     premium: {
    //         active: false,
    //         expiryTime: 0,
    //     },
    //     premium_plus: {
    //         active: true,
    //         expiryTime: moment().add(10, 'hours'),
    //     },
    //     premium_vip: {
    //         active: false,
    //         expiryTime: 0,
    //     },
    // })

    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[GET_PREMIUM_INFO_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'shop',
        params: {
            action: 'get_premium_info',
        },
        web_id: GET_PREMIUM_INFO_WEB_ID,
    })

    return promise
}

export function serverTimestamp() {
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[GET_SERVER_TIMESTAMP_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'util',
        params: {
            action: 'server_timestamp',
        },
        web_id: GET_SERVER_TIMESTAMP_WEB_ID,
    })

    return promise
}

/**
 * @param {string[]=} aliases
 * @returns {Promise<unknown>}
 */
export function getNewsCounters(aliases) {
    if (!isFunction(window.jsHostQuery)) {
        return Promise.reject(new Error('Cant get news counters'))
    }
    const promise = new Promise((resolve, reject) => {
        WoTClientMessageCallbacks[GET_NEWS_COUNTER_WEB_ID] = (data) => {
            if (Object.keys(data).length) {
                resolve(data)
            } else {
                reject(new Error('Cant get news counters'))
            }
        }
    })

    sendCommand({
        command: 'clan_management',
        params: {
            action: 'get_news_counters',
            aliases,
        },
        web_id: GET_NEWS_COUNTER_WEB_ID,
    })

    return promise
}

export function setNewsCounter(counterName, count) {
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[SET_NEWS_COUNTER_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'clan_management',
        params: {
            action: 'set_news_counter',
            alias: counterName,
            count,
        },
        web_id: SET_NEWS_COUNTER_WEB_ID,
    })

    return promise
}

export function getClanInfo() {
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[CLAN_INFO_STATUS] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'clan_management',
        params: {
            action: 'get_clan_info',
        },
        web_id: CLAN_INFO_STATUS,
    })

    return promise
}

export function showItemTooltip(type, count, id) {
    sendCommand({
        command: 'util',
        params: {
            action: 'show_item_tooltip',
            id,
            type,
            count,
        },
    })
}

export function showRewardBoxTooltip(x, y, rewards) {
    sendCommand({
        command: 'util',
        params: {
            action: 'show_additional_rewards_tooltip',
            x,
            y,
            rewards,
        },
    })
}

export function hideTooltip() {
    sendCommand({
        command: 'util',
        params: {
            action: 'hide_tooltip',
        },
    })
}

export function hideGamefaceTooltip() {
    sendCommand({
        command: 'util',
        params: {
            action: 'hide_window_tooltip',
        },
    })
}

/**
 *
 * @param {boolean} mute
 */
export function musicOnOff(mute) {
    sendCommand({
        command: 'hangar_sound',
        params: {
            mute,
        },
    })
}

export function getComparisonBasket() {
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[GET_COMPARISON_BASKET_WEB_ID] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'util',
        params: {
            action: 'get_comparison_basket',
        },
        web_id: GET_COMPARISON_BASKET_WEB_ID,
    })

    return promise
}

export function getAvailablePeripheries() {
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[GET_AVAILABLE_PERIPHERIES] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'strongholds_battle',
        params: {
            action: 'get_available_peripheries',
        },
        web_id: GET_AVAILABLE_PERIPHERIES,
    })

    return promise
}

export function requestVehicleParams(vehicleId) {
    const web_id = `${GET_VEHICLE_PARAMS_WEB_ID}_${vehicleId}`
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[web_id] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'vehicles',
        params: {
            action: 'vehicle_params',
            vehicle_id: vehicleId,
        },
        web_id,
    })

    return promise
}

export function requestVehicleInfo(vehicleId) {
    const web_id = `${GET_VEHICLE_INFO_WEB_ID}_${vehicleId}`
    const promise = new Promise(resolve => {
        WoTClientMessageCallbacks[web_id] = (data) => {
            resolve(data)
        }
    })

    sendCommand({
        command: 'vehicles',
        params: {
            action: 'vehicle_info',
            vehicle_id: vehicleId,
        },
        web_id,
    })

    return promise
}

export const openOverlayPage = (url) => {
    openWindow('browser_overlay', { url })
}

export function subscribeToChannel(name) {
    sendCommand({
        command: 'reactive_communication_service',
        params: {
            action: 'subscribe_to_channel',
            channel_name: name,
        },
    })
}

export function unsubscribeFromChannel(name) {
    sendCommand({
        command: 'reactive_communication_service',
        params: {
            action: 'unsubscribe_from_channel',
            channel_name: name,
        },
    })
}

export function getReserveSettings(intCDs, reserveType) {
    if (!isFunction(window.jsHostQuery)) {
        return Promise.reject(new Error('Cant get reserve settings'))
    }
    const web_id = `${GET_RESERVE_PARAMS_WEB_ID}_${reserveType}`
    const promise = new Promise((resolve, reject) => {
        WoTClientMessageCallbacks[web_id] = (data) => {
            if (data && Object.keys(data).length) {
                resolve(data)
            } else {
                reject(new Error('Cant get reserve settings'))
            }
        }
    })

    sendCommand({
        command: 'strongholds_battle',
        params: {
            action: 'get_reserve_params',
            reserve_intCDs: intCDs,
        },
        web_id,
    })

    return promise
}

export function openClanSupplyProgression() {
    sendCommand({
        command: 'open_tab',
        params: {
            tab_id: 'clan_supply',
            page: 0,
        },
    })
}

export function openClanSupplyQuests() {
    sendCommand({
        command: 'open_tab',
        params: {
            tab_id: 'clan_supply',
            page: 1,
        },
    })
}




// WEBPACK FOOTER //
// ./helpers/web_to_client.js